import { Checkbox, Form, Row } from "antd";

export const SaveAttachments = () => {
  return (
    <>
      <Row className="my-6 pr-6">
        <div className="w-100 divider" />
      </Row>
      <Form.Item
        name="saveOriginalAttachmentAsDocument"
        valuePropName="checked"
        className="mb-6 email-option"
      >
        <Checkbox>
          <Row className="d-block receipient-label">
            <p className="my-0 text-md elipsis">Save attachment to documents</p>
            <span className="text-sm title elipsis">
              Task attachment will be saved in the account’s Documents tab
            </span>
          </Row>
        </Checkbox>
      </Form.Item>
    </>
  );
};
